import type { TFunction } from 'i18next';
import { FrequencyValueSchema, isMultiFrequency, type FrequencyValue } from '@bliks-io/contracts';

/**
 * Localized frequency label, with an explicit occurrence count appended for the
 * "mehrmals" options (e.g. "Mehrmals täglich (5×)"). The count suffix is only
 * shown when a `timesPerPeriod` is actually stored — legacy surveys without one
 * render the plain label, so no false precision is implied.
 */
export function formatFrequency(
  value: string,
  timesPerPeriod: number | null | undefined,
  t: TFunction
): string {
  const label = t(`processes.frequency.${value}`, value);
  if (isMultiFrequency(value) && timesPerPeriod != null) {
    return `${label}${t('processes.frequency.timesSuffix', { count: timesPerPeriod })}`;
  }
  return label;
}

/**
 * The frequency dropdown options, in contract order. Labels come from the
 * `processPage.*` namespace, which both the step survey and the manual-capacity
 * dialog offer their choices from.
 */
export function frequencyOptions(t: TFunction): { value: FrequencyValue; label: string }[] {
  return FrequencyValueSchema.options.map((value) => ({
    value,
    label: t(`processPage.${value}`)
  }));
}
